import { gql } from '@apollo/client';

export interface StaffJoinCarpoolTripMutation {
  staffJoinCarpoolTrip: {
    id: string;
  };
}

export interface StaffJoinCarpoolTripMutationVariables {
  tripId: string;
  userId: string;
}

export const STAFF_JOIN_CARPOOL_TRIP = gql`
  mutation StaffJoinCarpoolTrip($tripId: ID!, $userId: ID!) {
    staffJoinCarpoolTrip(tripId: $tripId, userId: $userId) {
      id
    }
  }
`;
